import styles from './TagInput.module.scss';
import {IBasePickerSuggestionsProps, ITag, ITagItemProps, Label, TagItem, TagPicker} from '@fluentui/react';
import {useCallback, useMemo, useState} from 'react';

type ITagInput = {
  label: string
  elements: ITag[] | undefined;
  selectedItems: ITag[];
  inputLimit: number;
  setSelectedItems: React.Dispatch<React.SetStateAction<ITag[]>>;
  setValue: React.Dispatch<React.SetStateAction<ITag[]>>;
};

export const TagInput = ({
  label,
  elements,
  selectedItems,
  inputLimit,
  setSelectedItems,
  setValue,
}: ITagInput) => {


  const [removed, setRemoved] = useState<ITag[]>([]);

  const filterSuggestedTags = useCallback(
    (filterText: string, tagList: ITag[] | undefined): ITag[] => {
      return filterText
        ? (elements || []).filter(
            tag =>
              tag.name?.toLowerCase().includes(filterText.toLowerCase()) &&
              !listContainsTagList(tag, tagList)
          )
        : [];
    },
    [elements]
  );

  const onRemoveItems = useCallback(
    (removedItem: ITag) => {
      const newList = selectedItems.filter(item => item.key !== removedItem.key);
      setRemoved([...removed, removedItem]);
      setSelectedItems(newList);
      setValue(newList);
    },
    [selectedItems, removed, setValue, setSelectedItems]
  );

  const listContainsTagList = (tag: ITag, tagList?: ITag[]) => {
    if (!tagList || tagList.length === 0) {
      return false;
    }
    return tagList.some(compareTag => compareTag.key === tag.key);
  };

  const suggestionsProps: IBasePickerSuggestionsProps = useMemo(
    () => ({
      suggestionsHeaderText: 'Suggested element',
      noResultsFoundText: 'No element found',
    }),
    []
  );

  const onChange = useCallback(
    (items?: ITag[] | undefined) => {
      setSelectedItems(items || []);
      setValue(items || []);
      setRemoved(
        removed.filter(
          removedItem => items?.some(item => item.key === removedItem.key) === false
        )
      );
    },
    [removed, setValue, setSelectedItems]
  );

  const onRenderItem = useCallback(
    (props: ITagItemProps, index: number): JSX.Element => {
      return (
        <div
          key={props.item.name}>
          <TagItem
            onRemoveItem={() => onRemoveItems(props.item)}
            item={props.item}
            index={index}
            title={props.item.name}>
            {props.item.name}
          </TagItem>
        </div>
      );
    },
    [onRemoveItems]
  );

  return (
    <>
      <Label>{label}</Label>
      <div className={styles.inputWrapper}>
        <div className={styles.wrapperForRemoved}>
          <TagPicker
            className={styles.tagPicker}
            removeButtonAriaLabel="Remove"
            onRenderItem={piece => onRenderItem(piece, piece.index)}
            selectionAriaLabel="Selected elements"
            onResolveSuggestions={filterSuggestedTags}
            // getTextFromItem={(item: ITag) => item.name || ''}
            pickerSuggestionsProps={suggestionsProps}
            itemLimit={inputLimit}
            pickerCalloutProps={{doNotLayer: true}}
            selectedItems={selectedItems}
            onChange={onChange}
          />
        </div>
      </div>
    </>
  );
}
